import { Link } from "react-router-dom";

export const LOGO_URL = "/jollanda-logo.webp";

export const BrandLogo = ({ className = "h-10", testId = "brand-logo-link" }) => (
  <Link to="/" className="inline-flex items-center transition-opacity duration-200 hover:opacity-80" data-testid={testId} aria-label="Jollanda home">
    <img src={LOGO_URL} alt="Jollanda" className={`${className} w-auto object-contain`} />
  </Link>
);
